export default __webpack_public_path__ + "static/media/camera-icon.fdf0fa3f.svg";